import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=dd009cfe&scoped=true"
import script from "./balance.vue?vue&type=script&lang=js"
export * from "./balance.vue?vue&type=script&lang=js"
import style0 from "./balance.vue?vue&type=style&index=0&id=dd009cfe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd009cfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd009cfe')) {
      api.createRecord('dd009cfe', component.options)
    } else {
      api.reload('dd009cfe', component.options)
    }
    module.hot.accept("./balance.vue?vue&type=template&id=dd009cfe&scoped=true", function () {
      api.rerender('dd009cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/rights/redpacket/balance/balance.vue"
export default component.exports